var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-tooltip',{staticClass:"Tooltip",attrs:{"content":_vm.content,"placement":_vm.placement,"effect":"dark"}},[_c('i',{staticClass:"fas fa-question-circle"})])
}
var staticRenderFns = []

export { render, staticRenderFns }